/**
 * 统计时间筛选条件常量
 */

// 最近30天（按日分组）
export const CHART_TIME_TYPE_LAST_30_DAYS = 1;

// 最近12个月（按月分组）
export const CHART_TIME_TYPE_LAST_12_MONTHS = 3;

// 当月（按日分组）
export const CHART_TIME_TYPE_CURRENT_MONTH = 30;

// 当年（按月分组）
export const CHART_TIME_TYPE_CURRENT_YEAR = 40;

// 最近三年（按年分组）
export const CHART_TIME_TYPE_LAST_3_YEARS = 50;

/**
 * 时间筛选选项列表
 * 排序：当月 → 最近30天 → 当年 → 最近12月 → 最近3年
 */
export const CHART_TIME_TYPE_OPTIONS = [
  { id: CHART_TIME_TYPE_CURRENT_MONTH, name: '当月' },
  { id: CHART_TIME_TYPE_LAST_30_DAYS, name: '最近30天' },
  { id: CHART_TIME_TYPE_CURRENT_YEAR, name: '当年' },
  { id: CHART_TIME_TYPE_LAST_12_MONTHS, name: '最近12月' },
  { id: CHART_TIME_TYPE_LAST_3_YEARS, name: '最近三年' }
];
